import { localStg } from '@/utils/storage';
import type { Api } from '@/typings/api';

/** Get token */
export function getToken() {
  return localStg.get('token') || '';
}

/** Get user info */
export function getUserInfo() {
  const emptyInfo: Api.Auth.UserInfo = {
    id: '',
    token: '',
    locked: false,
    userName: '',
    realName: '',
    status: 1,
    phone: '',
    roles: [],
    roleList: [],
    menus: [],
    department: undefined,
    permissions: [],
    amountCheck: true
  };
  const userInfo = localStg.get('userInfo') || emptyInfo;

  return userInfo;
}

/** Clear auth storage */
export function clearAuthStorage() {
  localStg.remove('token');
  localStg.remove('refreshToken');
  localStg.remove('userInfo');
  localStg.remove('globalTabs');
}
